import { ActionReducerMap } from '@ngrx/store';

import {
  devicesReducer,
  DevicesState,
  DEVICES_FEATURE_KEY,
} from './devices/devices.reducer';
import {
  quotesReducer,
  QuotesState,
  QUOTES_FEATURE_KEY,
} from './quotes/quotes.reducer';

export const BASKET_FEATURE_KEY = 'basket';

export interface BasketState {
  [DEVICES_FEATURE_KEY]: DevicesState;
  [QUOTES_FEATURE_KEY]: QuotesState;
}

export interface BasketPartialState {
  [BASKET_FEATURE_KEY]: BasketState;
}

export const basketReducer: ActionReducerMap<BasketState> = {
  [DEVICES_FEATURE_KEY]: devicesReducer,
  [QUOTES_FEATURE_KEY]: quotesReducer,
};
